<!-- pin icon -->
<ng-template #pinIcon let-id="id">
    <i
        class="fa fa-thumb-tack"
        [ngStyle]="{
            color: pinnedDashboards.includes(id) ? '#bf9000' : '#7e94ac',
            transform: 'rotate(-45deg)',
            cursor: 'pointer',
        }"
        (click)="togglePin(id)"
        [title]="pinnedDashboards.includes(id) ? 'Unpin' : 'Pin'">
    </i>
</ng-template>

<!-- begin::Header -->
<header
    class="m-grid__item m-header px-0"
    data-minimize="minimize"
    data-minimize-offset="200"
    data-minimize-mobile-offset="200"
    appunwraptag=""
    style="z-index: 99999">
    <div class="m-header__top px-3" [class.is-scrolled]="isScrolled">
        <div class="m-container m-container--responsive m-container--full-height m-page__container px-3">
            <div class="m-stack m-stack--ver m-stack--desktop">
                <!-- begin::Brand -->
                <div class="m-stack__item m-brand">
                    <div class="m-stack m-stack--ver m-stack--general m-stack--inline">
                        <div class="m-stack__item m-stack__item--middle m-brand__tools mobile-view">
                            <button
                                id="m_aside_header_menu_mobile_toggle"
                                class="m-brand__icon m-brand__toggler"
                                type="button"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasMenu"
                                aria-controls="offcanvasMenu">
                                <span></span>
                            </button>
                            <a
                                id="m_aside_header_topbar_mobile_toggle"
                                href="javascript:;"
                                class="m-brand__icon m--visible-tablet-and-mobile-inline-block no-print">
                                <i class="flaticon-more"></i>
                            </a>
                        </div>
                        <div
                            class="m-stack__item m-stack__item--middle m-brand__logo mobile-view-logo"
                            [hidden]="!hideLHGLogo">
                            <a [routerLink]="homeRoute" class="m-brand__logo-wrapper" [attr.href]="homeHref">
                                <!-- Regular logo -->
                                <!-- <img
                alt="Pulse by RHG logo"
                src="./assets/app/media/img/logos/pulse_logo_h85-min.png"
                /> -->
                                <!-- New Regular logo -->
                                <img
                                    class="pulse-logo"
                                    [alt]="productService.theme.displayName + ' logo'"
                                    [src]="productService.theme.logo" />
                                <!-- Halloween logo -->
                                <!-- <img
                  class="pulse-logo"
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/pulse_logo_halloween_2025.png"
                  /> -->
                                <!-- <img
                  class="pulse-logo-hover"
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/pulse_logo_halloween_2025.gif"
                  /> -->
                                <!-- Christmas logo -->
                                <!-- <img
                  class="pulse-logo"
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/pulse-santa-sled-rudolf.gif"
                  /> -->
                                <!-- <img
                  class="pulse-logo-hover"
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/pulse-santa-sled.gif"
                  />  -->
                                <!-- Summer logo -->
                                <!-- <img
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/summer-logo.png"
                  /> -->
                                <!-- <img
                  class="pulse-logo-hover"
                  alt="Pulse by RHG logo"
                  src="./assets/app/media/img/logos/summer-logo.gif"
                  /> -->
                            </a>
                        </div>
                        <div
                            class="m-stack__item m-stack__item--middle m-brand__logo mobile-view-logo"
                            [hidden]="hideLHGLogo">
                            <a [routerLink]="homeRoute" class="m-brand__logo-wrapper" [attr.href]="homeHref">
                                <img class="pulse-logo" alt="Tenant logo" [src]="getLogoPath()" />
                            </a>
                        </div>
                        @if (hasSidebar) {
                            <div class="m-nav__item-container" id="load_status" (click)="openImportControl()">
                                <div id="status_kpi">
                                    <!-- When REGULAR LOGO - Uncomment padding-top in #load_status -->
                                    <span class="load_status_text">{{ 'header.status.rooms' | transloco }}</span>
                                    <mat-progress-spinner
                                        class="example-margin"
                                        [mode]="mode"
                                        [value]="value_rooms"
                                        diameter="22"
                                        [matTooltip]="rooms_tooltip"
                                        strokeWidth="5"
                                        [color]="getSpinnerColor(value_rooms)">
                                    </mat-progress-spinner>
                                    <span class="load_status_text" style="margin-right: 10px">{{ value_rooms }}%</span>
                                </div>
                                @if (isCompanyRHG()) {
                                    <div id="status_kpi">
                                        <span class="load_status_text">{{ 'header.status.me' | transloco }}</span>
                                        <mat-progress-spinner
                                            class="example-margin"
                                            [mode]="mode"
                                            [value]="value_me"
                                            diameter="22"
                                            [matTooltip]="me_tooltip"
                                            strokeWidth="5"
                                            [color]="getSpinnerColor(value_me)">
                                        </mat-progress-spinner>
                                        <span class="load_status_text">{{ value_me }}%</span>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>

                <!-- begin::Topbar -->
                <div class="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
                    <div id="m_header_topbar" class="m-topbar m-stack m-stack--ver m-stack--general">
                        <div class="m-stack__item m-topbar__nav-wrapper">
                            <ul class="m-topbar__nav m-nav m-nav--inline">
                                <li class="m-nav__item">
                                    <div class="m-nav__item-container" id="theme-switcher">
                                        <div ngbDropdown #headerDrop="ngbDropdown" class="no-close small no-padding">
                                            <div ngbDropdownToggle class="button no-anchor" style="cursor: pointer">
                                                @if (themeService.isDarkTheme()) {
                                                    <span class="m-topbar__welcome"> </span>
                                                }
                                                @if (!isCompanyLHG()) {
                                                    <a
                                                        class="badge-link"
                                                        (click)="openLeaderboard($event, headerDrop)"
                                                        [ngbTooltip]="'header.tooltips.openLeaderboard' | transloco"
                                                        placement="bottom"
                                                        aria-label="Open Leaderboard">
                                                        <badge-rating></badge-rating>
                                                    </a>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li class="m-nav__item">
                                    <div class="m-nav__item-container">
                                        <div
                                            ngbDropdown
                                            #headerDrop="ngbDropdown"
                                            [placement]="hasSidebar ? 'bottom-end' : 'bottom-start'"
                                            class="no-close small no-padding"
                                            (openChange)="onUserMenuOpen($event)">
                                            <div ngbDropdownToggle class="button no-anchor" style="cursor: pointer">
                                                <span class="m-topbar__welcome">
                                                    {{ 'header.greeting' | transloco }}&nbsp;
                                                </span>
                                                <span class="m-topbar__username">
                                                    {{ user?.first_name + ' ' }}&nbsp;
                                                </span>
                                                <span class="m-topbar__userpic">
                                                    <img
                                                        [src]="user?.profile_image | userImage | async"
                                                        class="m--img-rounded m--marginless m--img-centered"
                                                        id="header-image"
                                                        alt="user logo"
                                                        style="width: auto; height: auto; border-radius: 50%" />
                                                </span>
                                            </div>
                                            <div
                                                ngbDropdownMenu
                                                class="dropdown-content"
                                                style="padding: 0px; border: 0">
                                                <span class="p-dropdown-arrow"></span>
                                                <div class="p-dropdown-header">
                                                    <div class="m-card-user m-card-user--skin-dark">
                                                        <div class="m-card-user__pic">
                                                            <app-avatar></app-avatar>
                                                        </div>
                                                        <div class="m-card-user__details">
                                                            <span
                                                                class="m-card-user__name m--font-weight-500 text-white">
                                                                {{ user?.first_name }}
                                                                {{ user?.last_name }}
                                                            </span>
                                                            <span
                                                                class="m-card-user__email m--font-weight-300 m-link text-white">
                                                                {{ user?.title }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="p-dropdown-body">
                                                    <div class="p-dropdown-content">
                                                        <ul class="m-nav m-nav--skin-light">
                                                            <li class="m-nav__section m--hide">
                                                                <span class="m-nav__section-text"> Section </span>
                                                            </li>
                                                            <!-- Points / Stats -->
                                                            @if (!isCompanyLHG()) {
                                                                <li
                                                                    class="m-nav__item points-stats"
                                                                    aria-label="Points summary"
                                                                    role="group">
                                                                    <div class="points-stats">
                                                                        <div class="points-title">
                                                                            {{ 'header.points.title' | transloco }}
                                                                        </div>

                                                                        <div class="stats stats--three">
                                                                            <div class="stat">
                                                                                <div class="icon-pill total-icon">
                                                                                    <mat-icon>military_tech</mat-icon>
                                                                                </div>
                                                                                <div class="value total">
                                                                                    <!-- prettier-ignore -->
                                                                                    {{ (forumService.userPoints ?? 0) | number: '1.0-0' }}
                                                                                </div>
                                                                                <div class="label">
                                                                                    {{
                                                                                        'header.points.total'
                                                                                            | transloco
                                                                                    }}
                                                                                </div>
                                                                            </div>

                                                                            <div class="stat">
                                                                                <div class="icon-pill week-icon">
                                                                                    <mat-icon>trending_up</mat-icon>
                                                                                </div>
                                                                                <div class="value week">
                                                                                    <!-- prettier-ignore -->
                                                                                    {{ (forumService.weekPoints ?? 0) | number: '1.0-0' }}
                                                                                </div>
                                                                                <div class="label">
                                                                                    {{
                                                                                        'header.points.week' | transloco
                                                                                    }}
                                                                                </div>
                                                                            </div>

                                                                            <div class="stat">
                                                                                <div class="icon-pill next-icon">
                                                                                    <mat-icon>arrow_upward</mat-icon>
                                                                                </div>
                                                                                <div class="value next">
                                                                                    {{
                                                                                        forumService.getPointsToNextLevel
                                                                                    }}
                                                                                </div>
                                                                                <div class="label">
                                                                                    {{
                                                                                        'header.points.nextLevel'
                                                                                            | transloco
                                                                                    }}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="points-title">
                                                                        {{ pointsMessage }}
                                                                    </div>
                                                                </li>
                                                            }
                                                            @if (user?.access_level > 0) {
                                                                <li class="m-nav__item">
                                                                    <a
                                                                        ngbDropdownItem
                                                                        [routerLink]="['/admin']"
                                                                        class="m-nav__link">
                                                                        <i
                                                                            class="m-nav__link-icon flaticon-user-settings"></i>
                                                                        <span class="m-nav__link-text"> Admin </span>
                                                                    </a>
                                                                </li>
                                                            }
                                                            <li class="m-nav__item">
                                                                <a
                                                                    ngbDropdownItem
                                                                    [routerLink]="['/profile']"
                                                                    class="m-nav__link">
                                                                    <i class="m-nav__link-icon flaticon-user"></i>
                                                                    <span class="m-nav__link-text">{{
                                                                        'header.menu.profile' | transloco
                                                                    }}</span>
                                                                </a>
                                                            </li>

                                                            <!-- IF on /forum*, show the widget directly -->

                                                            <!-- ELSE, show a routerLink to /dashboard/achievments with the badge value -->
                                                            @if (!isCompanyLHG()) {
                                                                <li class="m-nav__item">
                                                                    <a
                                                                        ngbDropdownItem
                                                                        [routerLink]="['/achievements']"
                                                                        class="m-nav__link">
                                                                        <i class="m-nav__link-icon">
                                                                            <img
                                                                                src="assets/app/media/achievements/badge1-svgrepo-com.svg"
                                                                                width="20"
                                                                                alt="Achievements Icon" />
                                                                        </i>
                                                                        <span class="m-nav__link-text">
                                                                            Achievements
                                                                        </span>
                                                                        @if (info?.achievementsBadge) {
                                                                            <span class="m-nav__link-badge"> </span>
                                                                        }
                                                                    </a>
                                                                </li>
                                                            }

                                                            @if (user?.access_level > 0) {
                                                                <li class="m-nav__item">
                                                                    <a
                                                                        ngbDropdownItem
                                                                        [routerLink]="['/alerts']"
                                                                        class="m-nav__link">
                                                                        <i
                                                                            class="m-nav__link-icon flaticon-exclamation-2"></i>
                                                                        <span class="m-nav__link-text"> Alerts </span>
                                                                        @if (alertsService.totalAlertsNotClosed > 0) {
                                                                            <span class="m-nav__link-badge">
                                                                                <span class="m-badge m-badge--danger">
                                                                                    {{
                                                                                        alertsService.totalAlertsNotClosed
                                                                                    }}
                                                                                </span>
                                                                            </span>
                                                                        }
                                                                    </a>
                                                                </li>
                                                            }

                                                            <li class="m-nav__item">
                                                                <a
                                                                    class="m-nav__link"
                                                                    (click)="
                                                                        switchTheme(
                                                                            themeService.mode === 'light'
                                                                                ? 'dark'
                                                                                : 'light'
                                                                        );
                                                                        headerDrop.close()
                                                                    ">
                                                                    <i class="m-nav__link-icon">
                                                                        @if (themeService.mode === 'light') {
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="20"
                                                                                height="20"
                                                                                viewBox="0 0 24 24"
                                                                                fill="currentColor">
                                                                                <!-- Icono de luna -->
                                                                                <path
                                                                                    d="M21.64 13a9 9 0 01-11.64 8.49 9 9 0 001.44-17.73A9 9 0 0121.64 13z" />
                                                                            </svg>
                                                                        } @else {
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="20"
                                                                                height="20"
                                                                                viewBox="0 0 24 24"
                                                                                fill="currentColor">
                                                                                <!-- Icono de sol -->
                                                                                <path
                                                                                    d="M6.76 4.84l-1.8-1.79-1.42 1.41 1.79 1.8 1.43-1.42zm10.48 14.32l1.79 1.8 1.42-1.41-1.8-1.79-1.41 1.4zM12 4a1 1 0 011-1h.01a1 1 0 01.99 1v2a1 1 0 01-2 0V4zm0 14a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm8-6a1 1 0 01-1 1h-2a1 1 0 010-2h2a1 1 0 011 1zm-14 0a1 1 0 01-1 1H3a1 1 0 010-2h2a1 1 0 011 1zm11.66-5.66l1.8-1.79-1.41-1.42-1.79 1.8 1.4 1.41zM4.22 19.78l1.79-1.8-1.41-1.41-1.8 1.79 1.42 1.42z" />
                                                                                <circle cx="12" cy="12" r="5" />
                                                                            </svg>
                                                                        }
                                                                    </i>
                                                                    <span class="m-nav__link-text">
                                                                        {{
                                                                            themeService.mode === 'light'
                                                                                ? ('header.theme.dark' | transloco)
                                                                                : ('header.theme.light' | transloco)
                                                                        }}
                                                                    </span>
                                                                </a>
                                                            </li>

                                                            <!---------------------------------------->
                                                            <li class="m-nav__item">
                                                                <a
                                                                    class="m-nav__link"
                                                                    routerLink="/logout"
                                                                    (click)="headerDrop.close()">
                                                                    <i class="m-nav__link-icon flaticon-logout"></i>
                                                                    <span class="m-nav__link-text">{{
                                                                        'header.menu.logout' | transloco
                                                                    }}</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                        <!---------------------------------------->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                @if (hasSidebar) {
                                    <li class="m-nav__item">
                                        <span class="m-nav__link m-dropdown__toggle" id="sideBarButtonToggle">
                                            <span class="m-nav__link-icon m-nav__link-icon--aside-toggle">
                                                <button
                                                    type="button"
                                                    mat-icon-button
                                                    [ngbTooltip]="'header.tooltips.openHotelFilters' | transloco"
                                                    placement="bottom"
                                                    class="round-button"
                                                    (click)="openQuickSideBar()">
                                                    <i class="flaticon-menu-button"></i>
                                                </button>
                                            </span>

                                            <span (click)="openQuickSideBar()" class="m-nav__link-entity">
                                                @if (entityService.selectedEntityIds.length > 0) {
                                                    <span title="Number of hotels in your selection">
                                                        ({{ entityService.selectedEntityIds.length }})
                                                    </span>
                                                }
                                                {{ entityService.selectedEntityLabel }}
                                            </span>
                                        </span>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- end::Topbar -->
            </div>
        </div>
    </div>
    @if (supportAvailable) {
        <button
            type="button"
            class="pulse-header-support"
            [class.is-intro]="supportIntro"
            aria-label="Support"
            aria-haspopup="dialog"
            (click)="openSupport()">
            <i class="la la-life-ring" aria-hidden="true"></i>
            <span class="pulse-header-support__label" aria-hidden="true">Support</span>
        </button>
    }
</header>
<div
    class="offcanvas offcanvas-start"
    tabindex="-1"
    id="offcanvasMenu"
    data-bs-scroll="true"
    data-bs-backdrop="true"
    aria-labelledby="sidebar-menu-wrapper"
    style="z-index: 999999">
    <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="sidebar-menu-wrapper"></h5>
        <button
            type="button"
            class="{{
                globalService.localStorageItem('theme') == 'light'
                    ? 'btn-close text-reset'
                    : 'btn-close btn-close-white text-reset'
            }}"
            data-bs-dismiss="offcanvas"
            aria-label="Close"></button>
    </div>
    <div class="offcanvas-body text-center" id="sidebar-menu">
        <div class="m-stack__item m-stack__item--middle m-brand__logo" [hidden]="!hideLHGLogo">
            <a
                [routerLink]="homeRoute"
                class="m-brand__logo-wrapper"
                [attr.href]="homeHref"
                onclick="$('.offcanvas').offcanvas('hide')">
                <!-- Regular Logo -->
                <!-- <img
                    alt="Pulse by RHG logo"
                    src="./assets/app/media/img/logos/pulse_logo_h85-min.png"
                    /> -->

                <!-- New Regular logo -->
                <img
                    class="pulse-logo"
                    [alt]="productService.theme.displayName + ' logo'"
                    style="height: 110px"
                    [src]="productService.theme.logo" />
                <!-- Halloween Logo -->
                <!-- <img class="pulse-logo" alt="Pulse by RHG logo" style="height: 110px"
                      src="./assets/app/media/img/logos/pulse_logo_halloween_2025.png" />
                      <img class="pulse-logo-hover" alt="Pulse by RHG logo" style="height: 110px"
                        src="./assets/app/media/img/logos/pulse_logo_halloween_2025.gif" /> -->
                <!-- Christmas Logo -->
                <!-- <img
                        class="pulse-logo"
                        alt="Pulse by RHG logo"
                        style="height: 110px"
                        src="./assets/app/media/img/logos/pulse-santa-sled-rudolf.gif"
                        /> -->
                <!-- <img
                        class="pulse-logo-hover"
                        alt="Pulse by RHG logo"
                        style="height: 110px"
                        src="./assets/app/media/img/logos/pulse-santa-sled.gif"
                        /> -->
                <!-- Summer logo -->
                <!-- <img
                        class="pulse-logo"
                        alt="Pulse by RHG logo"
                        style="max-height: 200px"
                        src="./assets/app/media/img/logos/summer-logo-side.png"
                        />
                        Summer logo on hover -->
                <!-- <img
                        class="pulse-logo-hover"
                        alt="Pulse by RHG logo"
                        style="max-height: 200px"
                        src="./assets/app/media/img/logos/summer-logo.gif"
                        /> -->
            </a>
        </div>
        <div class="offcanvas-body text-center" id="sidebar-menu">
            <div class="m-stack__item m-stack__item--middle m-brand__logo" [hidden]="hideLHGLogo">
                <a class="m-brand__logo-wrapper" (click)="goToIndex(); hideOffcanvas()">
                    <img alt="" [src]="getLogoPath()" style="height: 110px" />
                </a>
            </div>
        </div>
        <!-- Product Switcher Strip -->
        @if (productSwitcherItems.length > 0) {
            <div class="product-switcher">
                <div class="product-switcher__items">
                    @for (item of productSwitcherItems; track item.product) {
                        <!-- Current product (active indicator) -->
                        @if (item.isCurrent) {
                            <div
                                class="product-switcher__item product-switcher__item--active"
                                [style.--ps-color]="item.accentColor"
                                [ngbTooltip]="item.displayName + ' (current)'"
                                placement="bottom"
                                container="body">
                                <div class="product-switcher__icon">
                                    <mat-icon>{{ item.icon }}</mat-icon>
                                </div>
                                <span class="product-switcher__label">{{ item.displayName }}</span>
                            </div>
                        }
                        <!-- Accessible product (clickable link) -->
                        @if (!item.isCurrent && item.hasAccess) {
                            <a
                                [href]="getSwitcherUrl(item)"
                                class="product-switcher__item product-switcher__item--enabled"
                                [style.--ps-color]="item.accentColor"
                                [ngbTooltip]="'Switch to ' + item.displayName"
                                placement="bottom"
                                container="body">
                                <div class="product-switcher__icon">
                                    <mat-icon>{{ item.icon }}</mat-icon>
                                </div>
                                <span class="product-switcher__label">{{ item.displayName }}</span>
                            </a>
                        }
                        <!-- Inaccessible product (disabled with tooltip) -->
                        @if (!item.isCurrent && !item.hasAccess) {
                            <a
                                [href]="item.url"
                                target="_blank"
                                class="product-switcher__item product-switcher__item--disabled"
                                [ngbTooltip]="
                                    'You don\'t have access to ' + item.displayName + ' yet. Click to subscribe.'
                                "
                                placement="bottom"
                                container="body"
                                tooltipClass="product-switcher-tooltip">
                                <div class="product-switcher__icon">
                                    <mat-icon>{{ item.icon }}</mat-icon>
                                </div>
                                <span class="product-switcher__label">{{ item.displayName }}</span>
                            </a>
                        }
                    }
                </div>
            </div>
        }

        @if (searchableDashboards.length > 10) {
            <div class="pulse-dashboard-search">
                <input
                    id="dashboard-menu-search"
                    type="search"
                    placeholder="Search dashboards"
                    [value]="dashboardSearch"
                    (input)="updateDashboardSearch($event)" />
                @if (dashboardSearch.trim()) {
                    <div class="pulse-dashboard-search-results" aria-live="polite">
                        @for (dashboard of dashboardSearchResults; track dashboard.product + '/' + dashboard.id) {
                            <a
                                [routerLink]="['/products', dashboard.product, 'dashboard', dashboard.id]"
                                (click)="closeOffCanvas()"
                                >{{ dashboard.name }}</a
                            >
                        } @empty {
                            <p>No dashboards match this search.</p>
                        }
                    </div>
                }
            </div>
        }
        <div class="accordion mt-4" id="mainMenu" [hidden]="searchableDashboards.length > 10 && dashboardSearch.trim()">
            @if (!hideLHGLogo) {
                <div>
                    <a
                        [routerLink]="['/products', 'insight', 'dashboard', 'index']"
                        class="home-btn"
                        data-bs-dismiss="offcanvas"
                        onclick="$('.collapse').collapse('hide')">
                        Home
                    </a>
                </div>
            }
            @if (pinnedDashboards.length > 0) {
                <div class="cat">
                    <div class="micro-label">My Dashboards</div>
                    <ul class="m-menu__subnav">
                        @for (dashboard of getPinnedDashboards(); track dashboard) {
                            <li class="d-flex align-items-center gap-2">
                                <i
                                    class="fa fa-thumb-tack"
                                    [ngStyle]="{
                                        color: '#bf9000',
                                        transform: 'rotate(-45deg)',
                                        cursor: 'pointer',
                                    }"
                                    (click)="togglePin(dashboard.id)"
                                    title="Unpin"></i>
                                <a
                                    [routerLink]="['/products', dashboard.product, 'dashboard', dashboard.id]"
                                    (click)="closeOffCanvas()"
                                    class="dashboard-link">
                                    <i class="m-menu__link-icon menu_icon flaticon-graphic-2"></i>
                                    {{ dashboard.name }}
                                </a>
                            </li>
                        }
                    </ul>
                </div>
                <div class="section-divider"></div>
            }

            @for (item of menu; track item) {
                <div class="cat">
                    <div class="cat-header" (click)="toggleMenuItem(item.name)">
                        <div class="cat-label-wrap">
                            <span class="cat-label">{{ item.label }}</span>
                            @if (item.show_badge && numberOfNews) {
                                <span
                                    matBadge="{{ numberOfNews }}"
                                    matBadgeColor="warn"
                                    matBadgeSize="small"
                                    style="top: -7px; right: -7px"></span>
                            }
                        </div>
                        <span class="chevron" [class.open]="openMenuItemName === item.name">
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </span>
                    </div>
                    <div class="cat-body-wrap" [class.open]="openMenuItemName === item.name">
                        <div class="cat-body-inner">
                            <div class="cat-body-content">
                                <!-- Dashboards -->
                                @if (item.label !== 'News') {
                                    <menu-section
                                        [items]="item.children"
                                        type="Dashboards"
                                        label="Dashboards"
                                        [defaultOpen]="true"
                                        [pinnedDashboards]="pinnedDashboards"
                                        (togglePin)="togglePin($event)">
                                    </menu-section>
                                }
                                <!-- News -->
                                @if (item.label === 'News') {
                                    <div>
                                        @for (element of news; track element; let j = $index) {
                                            @if (element.dashboard) {
                                                <div
                                                    class="accordion"
                                                    [id]="
                                                        element.dashboard !== null
                                                            ? element.dashboard.split(' ').join('') + '-n'
                                                            : element.dashboard
                                                    ">
                                                    <div class="accordion-item">
                                                        <h2 class="accordion-header" id="flush-headingOne">
                                                            <button
                                                                class="accordion-button collapsed"
                                                                type="button"
                                                                data-bs-toggle="collapse"
                                                                [attr.data-bs-target]="
                                                                    '#' +
                                                                    item.name +
                                                                    '-' +
                                                                    element.dashboard.split(' ').join('')
                                                                "
                                                                aria-expanded="false"
                                                                [attr.aria-controls]="element.dashboard">
                                                                {{ element.dashboard }}
                                                                @for (item of element.children; track item) {
                                                                    <span>
                                                                        @if (item.isNew) {
                                                                            <span
                                                                                style="
                                                                                    top: -5px;
                                                                                    right: -2px;
                                                                                    color: #bf9000;
                                                                                    font-weight: bold;
                                                                                    position: relative;
                                                                                    font-size: 8px;
                                                                                "
                                                                                >NEW</span
                                                                            >
                                                                        }
                                                                    </span>
                                                                }
                                                            </button>
                                                        </h2>
                                                        <div
                                                            [id]="
                                                                item.name + '-' + element.dashboard.split(' ').join('')
                                                            "
                                                            class="accordion-collapse collapse"
                                                            [attr.aria-labelledby]="element.dashboard"
                                                            [attr.data-bs-parent]="
                                                                '#' + element.dashboard.split(' ').join('') + '-n'
                                                            ">
                                                            <div class="accordion-body">
                                                                <ul class="m-menu__subnav" class="news-list">
                                                                    @for (
                                                                        child of element.children;
                                                                        track child;
                                                                        let i = $index
                                                                    ) {
                                                                        <li>
                                                                            <ng-container>
                                                                                <div
                                                                                    class="icon-container news-clickable"
                                                                                    data-bs-toggle="modal"
                                                                                    [attr.data-bs-target]="
                                                                                        '#modal' + j + '-' + i
                                                                                    ">
                                                                                    <div
                                                                                        class="news-icon"
                                                                                        [style.background]="
                                                                                            child.color
                                                                                        ">
                                                                                        <mat-icon
                                                                                            style="
                                                                                                color: white;
                                                                                                font-size: 16px;
                                                                                            "
                                                                                            >{{ child.icon }}</mat-icon
                                                                                        >
                                                                                    </div>
                                                                                    <div class="icontitle-container">
                                                                                        <span
                                                                                            class="m-subheader__title"
                                                                                            >{{ child.title }}</span
                                                                                        >
                                                                                    </div>
                                                                                </div>
                                                                            </ng-container>
                                                                        </li>
                                                                    }
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        }
                                    </div>
                                }
                                <!-- Settings -->
                                @if (item.has_presentation && item.label !== 'News' && isCompanyLHG()) {
                                    <menu-section
                                        [items]="item.children"
                                        type="Settings"
                                        label="Settings"
                                        [pinnedDashboards]="pinnedDashboards"
                                        (togglePin)="togglePin($event)">
                                    </menu-section>
                                }
                                <!-- Presentation -->
                                @if (item.has_presentation && item.label !== 'News' && item.label !== 'Settings') {
                                    <menu-section
                                        [items]="item.children"
                                        type="Custom Presentations"
                                        label="Presentations"
                                        [pinnedDashboards]="pinnedDashboards"
                                        (togglePin)="togglePin($event)">
                                    </menu-section>
                                }
                                @if (item.has_commercial_plan && item.label !== 'News' && item.label !== 'Settings') {
                                    <menu-section
                                        [items]="item.children"
                                        type="Commercial Plan"
                                        label="Commercial Plan"
                                        [pinnedDashboards]="pinnedDashboards"
                                        (togglePin)="togglePin($event)">
                                    </menu-section>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
<!-- end::Header -->
